/** Transkrip suara GPT-Live: potongan digabung apa adanya (spasi datang dari penyedia di depan kata baru), kecuali spasi setelah tanda baca. */

const LETTER = /\p{L}/u;
const WORD_CHAR = /[\p{L}\p{N}]/u;
/** Tanda baca akhir kalimat/klausa: kata yang menyusulnya harus diberi spasi. */
const CLAUSE_PUNCT = new Set([",", ".", ";", ":", "!", "?", "…"]);

/** Tambahkan `delta` ke `prev`; spasi awal transkrip dibuang; hanya kata yang menyusul tanda baca klausa diberi spasi. */
export function joinTranscript(prev: string, delta: string): string {
	if (!prev) return delta.trimStart();
	const last = prev.at(-1);
	const first = delta.at(0);
	if (last && first && CLAUSE_PUNCT.has(last) && LETTER.test(first)) {
		return `${prev} ${delta}`;
	}
	return prev + delta;
}

/**
 * Bentuk satu potongan untuk diagnosis, TANPA isinya: ada spasi di depan/belakang,
 * panjang, dan jenis (`word` = satu kata, `punct` = tanda baca saja, `mixed` = lainnya).
 */
export function describeDeltaShape(delta: string): string {
	const lead = /^\s/.test(delta) ? "sp" : "-";
	const trail = /\s$/.test(delta) ? "sp" : "-";
	const core = delta.trim();
	let kind = "mixed";
	if (core.length === 0) kind = "space";
	else if (!WORD_CHAR.test(core)) kind = "punct";
	else if (/^[\p{L}\p{N}]+$/u.test(core)) kind = "word";
	return `lead:${lead} trail:${trail} len:${delta.length} ${kind}`;
}
